import React, { useEffect, useState } from 'react';
import Sidebar from 'component/layout/sidebar/Sidebar';
import ChatConsoleView from 'component/organism/chat-console/ChatConsoleView';

import styles from './ChatConsole.module.scss';
import { useResponsive } from 'assets/styles/breakpoints/breakpoint';
import { useBrandingContext } from 'app-context/BrandingsContext';
import { useUserContext } from 'app-context/user/UserContext';

const ChatConsole = ({ hasBotId, disableConsole }) => {
  const { brandingData } = useBrandingContext();
  const { selectedBot, setSelectedBot } = useUserContext();
  const { isTablet } = useResponsive();
  const { page_TextColor, page_BackgroundColor } = brandingData;
  const [isOpen, setIsOpen] = useState(disableConsole ? 0 : -1);

  return (
    <div
      className={styles['chat-console']}
      style={{ backgroundColor: page_BackgroundColor, color: page_TextColor }}
    >
      {/* <Sidebar
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        hasCloseButton={true}
        isAbsolute
        isTablet={isTablet}
      /> */}

      <ChatConsoleView
        isOpen={isOpen}
        hasBotId={hasBotId}
        setIsOpen={setIsOpen}
        bot={selectedBot?.botId}
        disableConsole={disableConsole}
      />
    </div>
  );
};

export default ChatConsole;
